import React, { Component } from 'react';
import Img1 from "../images/Maevelifestyle/product1.png"
import Img2 from "../images/Maevelifestyle/product6.png"
import Img3 from "../images/Maevelifestyle/product7.png"
import Img4 from "../images/Maevelifestyle/product5.png"

export default class Gallery extends Component {

  render() {
  
    return (
      <div className='gallery-div pb-1'>
        <div className="container-fluid pb-5">
          <div className='gallery-head'>Gallery</div>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-12 p-0">
                <img src={Img1} alt="Img1" className='img-fluid border-white'/>
            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">

            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">
            <img src={Img2} alt="Img1" className='img-fluid border-white'/>
            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">

            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">

            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">
            <img src={Img3} alt="Img1" className='img-fluid border-white'/>
            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">

            </div>
            <div className="col-lg-3 col-md-3 col-12 p-0">
            <img src={Img4} alt="Img1" className='img-fluid border-white'/>
            </div>
          </div>  
        </div>
      </div>
    )
  }
}
